package at.theatervogelweide.admin.contract.club

import at.theatervogelweide.admin.contract.FieldError
import at.theatervogelweide.admin.contract.VersionedId
import at.theatervogelweide.admin.contract.validate
import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

/** The club's texts (#106) as the public site shows them on its Verein page and the start page; only superusers change them. */
@Serializable
data class Club(
    val version: Long,
    val draft: ClubDraft,
    /** Who on the board has the function [CONTACT_FUNCTION], whom the website names as the contact; `null` for nobody. */
    val contactPerson: String?,
    /** UTC, as stored in the database. */
    val changedAt: LocalDateTime,
    /** The person of the account that saved it last, or its e-mail address; `null` for the migration's texts or a deleted account. */
    val changedBy: String?,
) {
    val versionedId: VersionedId get() = VersionedId(ID, version)

    companion object {
        /** The one row there is. */
        const val ID = 1L

        /** The board function, as stored, of the club's contact person. */
        const val CONTACT_FUNCTION = "Obmann"
    }
}

/**
 * What a superuser saves: the short description in plain text, the text and "Mitmachen" in Markdown. The contact
 * e-mail is the Impressum's (#147).
 */
@Serializable
data class ClubDraft(
    val shortDescription: String = "",
    val text: String = "",
    val joinText: String = "",
) {
    fun validate(): List<FieldError> = validate {
        field(SHORT_DESCRIPTION, shortDescription) {
            required()
            maxLength(MAX_SHORT_DESCRIPTION)
        }
        field(TEXT, text) {
            required()
            maxLength(MAX_TEXT)
        }
        field(JOIN_TEXT, joinText) {
            required()
            maxLength(MAX_JOIN_TEXT)
        }
    }

    companion object {
        const val SHORT_DESCRIPTION = "shortDescription"
        const val TEXT = "text"
        const val JOIN_TEXT = "joinText"

        const val MAX_SHORT_DESCRIPTION = 300
        const val MAX_TEXT = 10000
        const val MAX_JOIN_TEXT = 2000
    }
}
